import VueRouter from "vue-router";
import { storage } from "./helpers/storage";

import Layout from "./views/index";
import AgendaLayout from "./views/agenda";
import EventAgendaSessionsList from "./views/agenda/event-agenda/sessions-list";
import EventAgendaDetail from "./views/agenda/event-agenda/event-agenda-detail";
import SessionEvaluations from "./views/agenda/session-evaluations";
import SessionQuiz from "./views/agenda/session-quiz";
import EventEvaluations from "./views/agenda/event-evaluations";
import EventQuiz from "./views/agenda/event-quiz";
import EventFollowUp from "./views/agenda/event-follow-up";
import EventSchedule from "./views/agenda/schedule";
import Certificate from "./views/agenda/certificate";
import Speakers from "./views/speakers";
import CEs from "./views/ce-info/CEs";
import CeInfo from "./views/ce-info";
import ExhibitHall from "./views/exhibit-hall";
import ExhibitHallSponsorView from "./views/exhibit-hall/view/index";
import SpeakerSessionModal from "./views/speakers/speaker-session-modal";
import UpgradeTicket from "./views/upgrade-ticket";
import UpgradeTicketSessionModal from "./views/upgrade-ticket/upgrade-ticket-session-modal/index.vue";
import ErrorPage from "./views/error-page";
import Access from "./views/access";
import EventSwitcher from "./views/enter-pages/event-switcher";
import Materials from "./views/materials";
import Home from "./views/home";
import ScanInOut from "./views/scan";
const commonPath = `/:attendeeId/dash`;

export const ROUTES = {
  // for authorize
  ACCESS: `/`,
  GUEST_EVENT_SWITCH: `/events-switcher`,
  // select event
  EVENT_SWITCH: `${commonPath}/events-switcher`,
  ERROR_PAGE: `${commonPath}/error/:status`,

  MAIN_LAYOUT: `${commonPath}`,
  AGENDA_LAYOUT: `${commonPath}`,
  AGENDA_EVENT: `${commonPath}`,
  AGENDA_HOME: `${commonPath}/home`,
  AGENDA_EVENT_DETAIL: `${commonPath}/agenda/sessions/:sessionId`,
  AGENDA_SCHEDULE: `${commonPath}/schedule`,
  AGENDA_SESSION_EVALUATION: `${commonPath}/agenda/sessions/:sessionId/evaluation`,
  AGENDA_SESSION_QUIZ: `${commonPath}/agenda/sessions/:sessionId/quiz`,
  AGENDA_EVALUATION: `${commonPath}/agenda/evaluation`,
  AGENDA_QUIZ: `${commonPath}/agenda/quiz`,

  EVENT_FOLLOW_UP: `${commonPath}/follow-up`,

  SPEAKERS: `${commonPath}/speakers`,
  SPEAKERS_SESSION_MODAL: `${commonPath}/speakers/sessions/:sessionId`,

  SCAN_IN_OUT: `${commonPath}/scan-in-out`,

  CE_INFO: `${commonPath}/ce-info`,
  CE_INFO_CES: `${commonPath}/ce-info`,
  CERTIFICATE: `${commonPath}/ce-info/certificate`,
  SINGLE_EVENT: `${commonPath}/single-event`,

  EXHIBIT_HALL: `${commonPath}/exhibit-hall`,
  EVENT_MATERIALS: `${commonPath}/materials`,
  EXHIBIT_HALL_SPONSOR_VIEW: `${commonPath}/exhibit-hall/:sponsorId`,

  UPGRADE_TICKET: `${commonPath}/upgrade-ticket`,
  UPGRADE_TICKET_SESSION_MODAL: `${commonPath}/upgrade-ticket/sessions/:sessionId`,
}

const routes = [
  {
    path: ROUTES.MAIN_LAYOUT,
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: ROUTES.AGENDA_LAYOUT,
        component: AgendaLayout,
        children: [
          {
            path: ROUTES.AGENDA_EVENT,
            component: EventAgendaSessionsList,
            name: 'Full Schedule',
          },
          {
            path: ROUTES.AGENDA_HOME,
            component: Home,
            name: 'Home',
          },
          {
            path: ROUTES.AGENDA_EVENT_DETAIL,
            component: EventAgendaDetail,
            name: 'Session Details',
          },
          {
            path: ROUTES.AGENDA_SESSION_EVALUATION,
            component: SessionEvaluations,
            name: 'Session Evaluation',
          },
          {
            path: ROUTES.AGENDA_SESSION_QUIZ,
            component: SessionQuiz,
            name: 'Session Quiz',
          },
          {
            path: ROUTES.AGENDA_SCHEDULE,
            component: EventSchedule,
            name: 'My Schedule',
          },
        ]
      },
      {
        path: ROUTES.AGENDA_EVALUATION,
        component: EventEvaluations,
        name: 'Event Evaluations',
      },
      {
        path: ROUTES.AGENDA_QUIZ,
        component: EventQuiz,
        name: 'Event Quiz',
      },
      {
        path: ROUTES.EVENT_FOLLOW_UP,
        component: EventFollowUp,
        name: 'Event Follow Up',
      },
      {
        path: ROUTES.SCAN_IN_OUT,
        component: ScanInOut,
        name: 'Scan in/out',
      },
      {
        path: ROUTES.SPEAKERS,
        component: Speakers,
        name: 'Speakers',
      },
      {
        path: ROUTES.SPEAKERS_SESSION_MODAL,
        component: SpeakerSessionModal,
        name: 'Speakers Session Details',
      },
      {
        path: ROUTES.CE_INFO,
        component: CeInfo,
        name: 'CE INFO',
        children:[
          {
            path: ROUTES.CE_INFO,
            component: CEs,
            name: 'CEs',
          },
          {
            path: ROUTES.CERTIFICATE,
            component: Certificate,
            name: 'My Certificate',
          },
        ]
      },
      {
        path: ROUTES.SINGLE_EVENT,
        component: Certificate,
        name: 'Single Event',
      },
      {
        path: ROUTES.EXHIBIT_HALL,
        component: ExhibitHall,
        name: 'Exhibit Hall',
      },
      {
        name: 'Event Materials',
        path: ROUTES.EVENT_MATERIALS,
        component: Materials,
      },
      {
        path: ROUTES.EXHIBIT_HALL_SPONSOR_VIEW,
        component: ExhibitHallSponsorView,
        name: 'Exhibit Hall Sponsor View',
      },
      {
        path: ROUTES.UPGRADE_TICKET,
        component: UpgradeTicket,
        name: 'Upgrade Ticket',
      },
      {
        path: ROUTES.UPGRADE_TICKET_SESSION_MODAL,
        component: UpgradeTicketSessionModal,
        name: 'Upgrade Ticket Session Detail',
      },
    ],
  },
  {
    meta: { guestOnly: true },
    path: ROUTES.ACCESS,
    component: Access,
    name: 'Access',
  },
  {
    path: ROUTES.GUEST_EVENT_SWITCH,
    component: EventSwitcher,
    name: 'Guest Event Switcher',
  },
  {
    path: ROUTES.EVENT_SWITCH,
    component: EventSwitcher,
    name: 'Event Switcher',
  },
  {
    path: ROUTES.ERROR_PAGE,
    name: 'Error Page',
    component: ErrorPage,
    props: true,
  },
  {
    path: `/:attendeeId/*`,
    redirect: (to) => {
      return {
        name: 'Error Page',
        params: {
          status: 404,
          attendeeId: to.params.attendeeId
        }
      }
    },
  },
];



const router = new VueRouter({
  hashbang: false,
  history: true,
  mode: 'history',
  base: `conference/attendee`, // window.attendeeId - init in /resources/views/new-attendee/index.blade.php
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // console.log(savedPosition);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({...savedPosition})
        }, 50)
      })
      return savedPosition
    } else {
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  }
});

// async function isAuthenticated() {
//   // Спочатку перевіряємо чи є токен в URL параметрах
//   const param = new URLSearchParams(window.location.search);
//   const tokenFromUrl = param.get('token');
//
//   if (tokenFromUrl) {
//     return true; // Якщо токен є в URL, вважаємо користувача автентифікованим
//   }
//
//   // Інакше перевіряємо storage
//   const token = await storage.getItem('token');
//   return !!token;
// }

async function isAuthenticated() {
  // Спочатку перевіряємо чи є токен в URL параметрах
  const param = new URLSearchParams(window.location.search);
  const tokenFromUrl = param.get('token');

  if (tokenFromUrl) {
    return true;
  }

  // Інакше перевіряємо storage
  const token = await storage.getItem('token');
  let hasToken;
  hasToken = !!token;

  return hasToken;
}

router.beforeEach(async(to, from, next) => {
  const loggedIn = await isAuthenticated();

  // if unauthorized
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    return next(ROUTES.ACCESS);
  }

  // if authorized and try to go to login page
  if (to.matched.some(record => record.meta.guestOnly) && loggedIn) {
    // Якщо користувач вже залогінений і намагається перейти на сторінку логіну
    // Просто залишаємо його на поточній сторінці
    if (from.name) {
      return next(false);
    } else {
      // Якщо це перший візит (немає from), дозволяємо компоненту Access
      // зробити редірект самостійно
      return next();
    }
  }

  return next();
});

export default router;
